var _style, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogonew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 454 90",
    style: {
      enableBackground: "new 0 0 454 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000008150134744471043050000016786222189688952255_);}\n\t.st2{fill:url(#SVGID_00000065796735893998046310000011380024428336969365_);}\n\t.st3{fill:#282828;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1331.905,
    y1: 499.1219,
    x2: 1415.538,
    y2: 499.1219,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 -581.7957 -1279.421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#692BE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E24B5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,66.1l-9.6-9.6c0.1,1.3,0,2.7-0.4,4c-0.6,2.1-1.7,4-3.2,5.5c-0.6,0.6-1.3,1.1-2,1.6 c-0.7,0.5-1.5,0.9-2.4,1.2c-1.4,0.5-2.9,0.8-4.4,0.8c-3.3,0-6.4-1.3-8.8-3.6L15.4,41.2c-3.4-3.4-4.5-8.6-2.8-13.2 c0.6-1.6,1.6-3.1,2.8-4.3c1.5-1.5,3.5-2.6,5.5-3.2c1-0.3,2.1-0.4,3.2-0.4c3.1,0,6,1.1,8.3,3.2c0.2,0.1,0.3,0.3,0.5,0.4l9.6,9.6 c-0.1-1.8,0.1-3.6,0.8-5.3c0.6-1.6,1.6-3.1,2.8-4.3c0.6-0.6,1.3-1.1,2-1.6l-6.8-6.8c-0.6-0.6-1.2-1.1-1.8-1.6 c-4.3-3.5-9.7-5.5-15.4-5.5c-2.1,0-4.2,0.3-6.2,0.8c-4.1,1.1-7.9,3.3-10.9,6.3c-2.4,2.4-4.3,5.3-5.5,8.5 c-3.4,8.9-1.2,19,5.5,25.8L32,74.4c4.6,4.6,10.6,7.1,17.1,7.1c3,0,5.9-0.5,8.6-1.6c2.5-0.9,4.7-2.2,6.7-3.9 c0.6-0.5,1.2-1,1.8-1.6c2.3-2.3,4.1-5,5.3-7.9C71.3,66.4,71.2,66.2,71,66.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146491885806950736480000007419979030707595678_",
    gradientUnits: "userSpaceOnUse",
    x1: 1353.6077,
    y1: 477.4193,
    x2: 1437.2406,
    y2: 477.4193,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 -581.7957 -1279.421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#692BE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E24B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146491885806950736480000007419979030707595678_)"
    },
    d: "M101.7,66.1l-9.6-9.6 c0.1,1.3,0,2.7-0.4,4c-0.6,2.1-1.7,4-3.2,5.5c-0.6,0.6-1.3,1.1-2,1.6c-0.7,0.5-1.5,0.9-2.4,1.2c-1.4,0.5-2.9,0.8-4.4,0.8 c-3.1,0-6-1.1-8.3-3.2c-0.2-0.1-0.3-0.3-0.5-0.4l-9.6-9.6c0.1,1.3,0,2.7-0.4,4c-0.6,2.1-1.7,4-3.2,5.5c-0.6,0.6-1.3,1.1-2,1.6 l6.8,6.8c0.6,0.6,1.2,1.1,1.8,1.6c4.3,3.5,9.7,5.5,15.3,5.5c3,0,5.9-0.5,8.6-1.6c2.5-0.9,4.7-2.2,6.7-3.9c0.6-0.5,1.2-1,1.8-1.6 c2.3-2.3,4.1-5,5.3-7.9C102,66.4,101.9,66.2,101.7,66.1z M63.6,23.7l9.6,9.6c-0.1-1.8,0.1-3.6,0.8-5.3c0.6-1.6,1.6-3.1,2.8-4.3 c0.6-0.6,1.3-1.1,2-1.6L72,15.3c-0.6-0.6-1.2-1.1-1.8-1.6c-4.3-3.5-9.7-5.5-15.4-5.5c-2.1,0-4.2,0.3-6.2,0.8 c-3.3,0.9-6.4,2.5-9.1,4.7c-0.6,0.5-1.2,1-1.8,1.6c-2.3,2.3-4.1,5-5.3,7.9c0.2,0.1,0.3,0.3,0.5,0.4l9.6,9.6 c-0.1-1.8,0.1-3.6,0.8-5.3c0.6-1.6,1.6-3.1,2.8-4.3c0.6-0.6,1.3-1.1,2-1.6c1.1-0.7,2.3-1.3,3.6-1.6c1-0.3,2.1-0.4,3.2-0.4 c3.1,0,6,1.1,8.3,3.2C63.3,23.4,63.5,23.5,63.6,23.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062911457780498994350000015507129640074600835_",
    gradientUnits: "userSpaceOnUse",
    x1: 1375.3103,
    y1: 455.7166,
    x2: 1458.9432,
    y2: 455.7166,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 -581.7957 -1279.421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#692BE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E24B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062911457780498994350000015507129640074600835_)"
    },
    d: "M127.6,40.2l-24.9-24.9 c-4.6-4.6-10.6-7.1-17.1-7.1c-2.1,0-4.2,0.3-6.2,0.8c-3.3,0.9-6.4,2.5-9.1,4.7c-0.6,0.5-1.2,1-1.8,1.6c-2.3,2.3-4.1,5-5.3,7.9 c0.2,0.1,0.3,0.3,0.5,0.4l9.6,9.6c-0.1-1.8,0.1-3.6,0.8-5.3c0.6-1.6,1.6-3.1,2.8-4.3c0.6-0.6,1.3-1.1,2-1.6 c1.1-0.7,2.3-1.3,3.6-1.6c1-0.3,2.1-0.4,3.2-0.4c3.3,0,6.4,1.3,8.8,3.6l24.9,24.9c3.1,3.1,4.3,7.7,3.2,12c-0.6,2.1-1.7,4-3.2,5.5 c-1.2,1.2-2.7,2.2-4.3,2.8c-1.4,0.5-2.9,0.8-4.4,0.8c-3.1,0-6-1.1-8.3-3.2c-0.2-0.1-0.3-0.3-0.5-0.4l-9.6-9.6 c0.1,1.3,0,2.7-0.4,4c-0.6,2.1-1.7,4-3.2,5.5c-0.6,0.6-1.3,1.1-2,1.6l6.8,6.8c0.6,0.6,1.2,1.1,1.8,1.6c4.3,3.5,9.7,5.5,15.3,5.5 c3,0,5.9-0.5,8.6-1.6c3.2-1.2,6.1-3.1,8.5-5.5c3-3,5.2-6.8,6.3-10.9C136.1,55.2,133.7,46.3,127.6,40.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.6,71.7c-4.9,0-7.3-2.5-7.3-7.6V28.9c0-5,2.4-7.5,7.1-7.5c4.8,0,7.1,2.5,7.1,7.5v0.3 c1.4-2.5,3.4-4.5,5.8-5.9c2.5-1.4,5.3-2.1,8.6-2.1c3.3,0,6.2,0.8,8.5,2.3c2.3,1.5,4.1,3.8,5.3,6.9c1.5-2.9,3.6-5.2,6.4-6.8 c2.8-1.6,5.9-2.4,9.3-2.4c5.4,0,9.4,1.7,12,5c2.6,3.3,4,8.5,4,15.4v22.5c0,2.4-0.6,4.3-1.9,5.7s-3,2-5.3,2c-4.9,0-7.3-2.5-7.3-7.6 v-22c0-3.2-0.5-5.6-1.5-7.1c-1-1.5-2.7-2.2-5.1-2.2c-2.8,0-4.9,1-6.5,3c-1.5,2-2.3,4.8-2.3,8.4v19.9c0,5.1-2.4,7.6-7.2,7.6 c-2.3,0-4.1-0.7-5.4-2c-1.3-1.3-1.9-3.2-1.9-5.7v-22c0-3.2-0.5-5.6-1.5-7.1c-1-1.5-2.7-2.2-5-2.2c-2.8,0-4.9,1-6.5,3 c-1.5,2-2.3,4.8-2.3,8.4v19.9C169.8,69.2,167.4,71.7,162.6,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.4,71.9c-5.6,0-10.4-1-14.4-3.1c-4-2.1-7.1-5-9.3-8.8c-2.2-3.8-3.2-8.3-3.2-13.4c0-5,1-9.4,3.1-13.2 c2.1-3.8,4.9-6.8,8.6-8.9c3.6-2.1,7.8-3.2,12.6-3.2c6.9,0,12.3,2.2,16.4,6.7c4,4.5,6.1,10.5,6.1,18.1c0,2.5-1.5,3.8-4.5,3.8h-28.3 c0.5,3.8,1.9,6.6,4.1,8.4c2.2,1.8,5.3,2.6,9.2,2.6c1.5,0,3.3-0.2,5.3-0.5c2-0.4,3.8-1,5.6-1.9c1.9-0.9,3.4-1.1,4.7-0.5 c1.3,0.6,2.2,1.5,2.7,2.8c0.5,1.3,0.5,2.7,0,4.1c-0.5,1.4-1.6,2.6-3.2,3.5c-2.2,1.3-4.7,2.2-7.5,2.8 C270.5,71.6,267.9,71.9,265.4,71.9z M263.3,31.1c-3.1,0-5.6,1-7.5,2.9c-1.9,1.9-3.1,4.6-3.5,8h20.8 C272.8,34.7,269.5,31.1,263.3,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301,71.7c-4.9,0-7.3-2.5-7.3-7.6V28.9c0-5,2.4-7.5,7.1-7.5c4.8,0,7.1,2.5,7.1,7.5v0.4 c1.6-2.6,3.8-4.7,6.5-6.1c2.7-1.4,5.7-2.1,9.1-2.1c5.6,0,9.8,1.7,12.5,5c2.8,3.3,4.1,8.5,4.1,15.4v22.5c0,5.1-2.4,7.6-7.3,7.6 c-2.3,0-4.1-0.7-5.3-2c-1.3-1.3-1.9-3.2-1.9-5.7V42.3c0-3.4-0.6-5.8-1.8-7.3c-1.2-1.5-3-2.2-5.4-2.2c-3.1,0-5.5,1-7.4,3 c-1.8,2-2.7,4.6-2.7,7.9v20.4C308.3,69.2,305.9,71.7,301,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M369.5,71.9c-4.1,0-7.7-1-10.8-3.1c-3.1-2.1-5.5-5-7.3-8.8c-1.7-3.8-2.6-8.3-2.6-13.5c0-5.2,0.9-9.7,2.6-13.5 c1.7-3.8,4.2-6.7,7.3-8.7c3.1-2,6.7-3.1,10.8-3.1c3.1,0,6,0.7,8.7,2.1c2.6,1.4,4.6,3.2,6,5.6V7.6c0-5.1,2.4-7.6,7.2-7.6 c4.9,0,7.3,2.5,7.3,7.6v56.5c0,5.1-2.4,7.6-7.2,7.6c-4.8,0-7.2-2.5-7.2-7.6v-0.3c-1.3,2.5-3.3,4.5-5.9,6 C375.6,71.2,372.7,71.9,369.5,71.9z M373.8,60.7c3.1,0,5.6-1.2,7.6-3.5c2-2.3,2.9-5.9,2.9-10.8c0-4.8-1-8.4-2.9-10.7 c-2-2.3-4.5-3.4-7.6-3.4c-3.1,0-5.6,1.1-7.5,3.4c-1.9,2.3-2.9,5.8-2.9,10.7c0,4.9,1,8.5,2.9,10.8 C368.2,59.6,370.7,60.7,373.8,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M422.8,89.6c-2.6,0-4.4-1-5.4-2.9c-1.1-2-1-4.2,0.1-6.8l5.1-11.7l-15.7-37.1c-1-2.6-1-4.8,0-6.8 c1.1-2,3.2-2.9,6.4-2.9c1.7,0,3.1,0.4,4.2,1.2c1.1,0.8,2,2.4,2.9,4.7l9.8,25.8l10.2-25.9c0.9-2.2,1.9-3.8,3-4.6 c1.1-0.8,2.7-1.2,4.6-1.2c2.4,0,4.2,1,5.2,2.9c1,2,0.9,4.2-0.1,6.7l-22.7,52.9c-1,2.2-2,3.8-3.2,4.6 C426.1,89.2,424.6,89.6,422.8,89.6z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonew);
export default __webpack_public_path__ + "static/media/logonew.50dc7c797a55083bb645c4ed37e5d1b6.svg";
export { ForwardRef as ReactComponent };